export default "__VITE_ASSET__Bwu5kfLX__"